import * as React from 'react';

type AccessibleModulesContext = string[];

export const AccessibleModulesContext = React.createContext<AccessibleModulesContext>([]);
